import * as THREE from "three";
import {DecalGeometry} from "three/addons/geometries/DecalGeometry";


import createPlaneFromSection from "./createPlaneFromSection";
export class GenerateDecal extends THREE.Mesh {
    constructor({
        plane,
        size,
        material,
        type = "section",
        userData = {},
        layer = 1,
        name = "decal",
    }) {
        
        const product = window.threeViewer.product
        let quaternion = new THREE.Quaternion();
        let euler = new THREE.Euler();
        let geometryPlane = createPlaneFromSection(plane);
        let meshWorldPos = plane.getWorldPosition(new THREE.Vector3()).clone();
        let pos = meshWorldPos.clone();
        pos.y = 0;
        let dir = pos.clone().negate().normalize();
        let ray = new THREE.Ray(meshWorldPos, dir);
        let rayCaster = new THREE.Raycaster(ray.origin, ray.direction);
        
        rayCaster.params.Points.threshold = 0.01;
        let intersects = rayCaster.intersectObject(product, true);
        
        plane.getWorldQuaternion(quaternion);
        euler.setFromQuaternion(quaternion, 'XYZ');
        
        
        if (intersects?.length) {
			
			const target = window.threeViewer.product.getObjectByName("engraving_target");
			const object = target ?? intersects[0].object;
			const point = intersects[0].point;
            
            const decalGeometry = new DecalGeometry(object, point, euler, size);
            super(decalGeometry);
            
            this.plane = geometryPlane
            this.originPlane = new THREE.Plane(this.plane.normal.clone(), 0)
            this.material = material
            this.type = type
            this.layers.set(layer)
            this.userData = userData
            this.name = name
            this.euler = euler
            this.object = object
            this.point = point
            this.size = size
            
            this.distance = this.originPlane.distanceToPoint(this.point)
            
            this.highlight = {
                on: this.highlightOn.bind(this),
                off: this.highlightOff.bind(this),
                state: false
            }
            
        } else {
            super();
            this.error = true
        }
        
    }
    
    highlightOn = (count) => {
        if (!this.highlight.state) {
            this.material.map.dispose()
            
            if (!count) {
                this.material.map = this.userData.textures.hoverText
            } else {
                this.material.map = this.userData.textures.hover
            }
            this.highlight.state = true
            this.material.needsUpdate = true
        }
    }
    highlightOff = (state) => {
        if (this.highlight.state || state) {
            this.material.map.dispose()
            this.material.map = this.userData.textures.normal
            this.highlight.state = false
            this.material.needsUpdate = true
        }
        
    }
 
    
    
}
